import PropTypes from 'prop-types';
import React from 'react';

import { theme } from 'src/styles/theme';

const SVG = props => (
  <svg fill="none" height="23" viewBox="0 0 24 23" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.144 7.95311L16.063 6.9439L12.9 0.655211C12.808 0.502072 12.6769 0.375127 12.5196 0.286931C12.3623 0.198736 12.1842 0.152344 12.003 0.152344C11.8218 0.152344 11.6437 0.198736 11.4864 0.286931C11.3291 0.375127 11.198 0.502072 11.106 0.655211L7.937 6.9439L0.856002 7.95311C0.671342 7.97926 0.497822 8.05554 0.355058 8.17335C0.212294 8.29116 0.105981 8.44578 0.048137 8.61975C-0.00970661 8.79372 -0.0167734 8.98009 0.0277356 9.1578C0.0722445 9.3355 0.166554 9.49744 0.300002 9.62533L5.425 14.5233L4.216 21.4406C4.18449 21.621 4.20506 21.8064 4.27538 21.9759C4.3457 22.1454 4.46297 22.2923 4.61393 22.3998C4.76489 22.5073 4.94352 22.5713 5.12961 22.5845C5.31571 22.5977 5.50185 22.5595 5.667 22.4744L12 19.2094L18.333 22.4744C18.4981 22.5595 18.6843 22.5977 18.8704 22.5845C19.0565 22.5713 19.2351 22.5073 19.3861 22.3998C19.537 22.2923 19.6543 22.1454 19.7246 21.9759C19.7949 21.8064 19.8155 21.621 19.784 21.4406L18.575 14.5233L23.7 9.62533C23.8334 9.49757 23.9277 9.33578 23.9724 9.15823C24.017 8.98067 24.0101 8.79441 23.9525 8.62049C23.8948 8.44658 23.7888 8.29192 23.6463 8.17399C23.5038 8.05606 23.3305 7.97956 23.146 7.95311H23.144Z"
      fill={theme.palette.common[props.color]}
    />
  </svg>
);

SVG.propTypes = {
  color: PropTypes.string,
};

SVG.defaultProps = {
  color: 'gray300',
};

export default SVG;
